import { useParams } from "react-router-dom";
import AccessLog from "datasets/pages/settings/types/interfaces/access-log";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

const useAccessLogs = () => {
  const { datasetId } = useParams();
  return useFetcher<AccessLog[]>(
    datasetId ? `${VITE_CATALOG_API}/datasets/${datasetId}/access-logs` : null
  );
};

export default useAccessLogs;
